/**
 * Client fuer die n8n-Webhooks (Formulare, Newsletter, Lead-Magnete, Wizard-Mail, Bilddiagnose).
 * @module shared/services/n8n-client
 */
import { N8N, getPageLocale } from './config.js';

/**
 * Sendet JSON an einen benannten Webhook. Die Sprache der Seite geht immer mit (locale),
 * damit n8n Liste, Vorlage und Absender je Sprache waehlen kann.
 * @param {keyof typeof N8N.endpoints} endpoint Name aus config (z. B. 'newsletter')
 * @param {Record<string, unknown>} payload Daten
 * @param {object} [options] Optionen
 * @param {typeof fetch} [options.fetchImpl] eigene fetch-Funktion (Tests)
 * @returns {Promise<Record<string, unknown>>} Antwort des Webhooks (leeres Objekt, wenn kein JSON)
 */
export async function postWebhook(endpoint, payload, { fetchImpl = globalThis.fetch } = {}) {
  const path = N8N.endpoints[endpoint];
  if (!path) throw new Error(`Unbekannter n8n-Endpunkt: ${endpoint}`);
  const locale = getPageLocale();
  const response = await fetchImpl(`${N8N.baseUrl}/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ locale: locale.code, sprache: locale.language, ...payload }),
  });
  if (!response.ok) throw new Error(`n8n ${endpoint}: HTTP ${response.status}`);
  const text = await response.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return {};
  }
}
